import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { AppRequestService, AppMessageFactory } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared';
import { PasswordResetMailByAdminRequest } from '@common/auth-strategy-credentials/shared';
import { ClassName } from '@core/shared/class-name';
import { roleCheck, UserRole } from '@core/shared/access';
import * as i0 from "@angular/core";
let AuthStrategyCredentialsFrontendAdminFeature = /*#__PURE__*/(() => {
  let AuthStrategyCredentialsFrontendAdminFeature = class AuthStrategyCredentialsFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/auth-strategy-credentials/frontend-admin","featureId":"common-auth-strategy-credentials"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineItemActions([{
        modelId: 'UserItem',
        displayContext: ['admin', 'crud'],
        label: 'Passwort-Reset Mail senden',
        icon: "envelope-open-text",
        enableIf: item => {
          return item.email && !roleCheck(UserRole.ADMINISTRATOR, item.userRole);
        },
        action: item => {
          const api = this.injector.get(AppRequestService);
          api.sendRequest(PasswordResetMailByAdminRequest, {
            userId: item.id
          }).subscribe({
            next: response => {
              const msg = this.injector.get(AppMessageFactory);
              if (response.success) {
                msg.create('Eine Passwort-Reset-Email wurde gesendet.').setSeverity('success');
              } else {
                msg.create('Die Passwort-Reset-Mail konnte nicht gesendet werden.').setSeverity('warn');
              }
            },
            error: err => {}
          });
        }
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵAuthStrategyCredentialsFrontendAdminFeature_BaseFactory;
        return function AuthStrategyCredentialsFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵAuthStrategyCredentialsFrontendAdminFeature_BaseFactory || (ɵAuthStrategyCredentialsFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(AuthStrategyCredentialsFrontendAdminFeature)))(__ngFactoryType__ || AuthStrategyCredentialsFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: AuthStrategyCredentialsFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  };
  AuthStrategyCredentialsFrontendAdminFeature = __decorate([ClassName("AuthStrategyCredentialsFrontendAdminFeature")], AuthStrategyCredentialsFrontendAdminFeature);
  return AuthStrategyCredentialsFrontendAdminFeature;
})();
export { AuthStrategyCredentialsFrontendAdminFeature };